import { getClickedLinkElement } from './log_link_clicks/get_clicked_link_element';
import { getClickedLinkElementLabel } from './log_link_clicks/get_clicked_link_element_label';
import { addLevel2ParentLabel } from './log_link_clicks/add_level_2_parent_label';
import { addLevel1ParentLabel } from './log_link_clicks/add_level_1_parent_label';
import { sendClickToGa } from './log_link_clicks/send_click_to_ga';

const onLinkClick = level => event => {
    const $linkElement = getClickedLinkElement(event);

    let labelElements = [
        getClickedLinkElementLabel(level, $linkElement),
    ];

    if (level > 2) {
        addLevel2ParentLabel(labelElements, $linkElement);
    }

    if (level > 1) {
        addLevel1ParentLabel(labelElements, $linkElement);
    }

    sendClickToGa(level, labelElements);
};

export const logLinkClicks = () => {
    $('.navigation-level-1__link[href]:not([href=""])').on('click', onLinkClick(1));
    $('.navigation-level-2__link[href]:not([href=""])').on('click', onLinkClick(2));
    $('.navigation-level-3__link[href]:not([href=""])').on('click', onLinkClick(3));
};
